var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagination',{attrs:{"records":_vm.paginationParams.total},on:{"paginate":_vm.myCallback},model:{value:(_vm.paginationParams.page),callback:function ($$v) {_vm.$set(_vm.paginationParams, "page", $$v)},expression:"paginationParams.page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }